<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
useHead({
  title: 'The Players League',
  meta: [
    // Viewport configuration for mobile devices
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=5.0' },
    { name: 'description', content: 'Competitive Pool League in Fort Worth, Texas featuring Bad Boys Tru-Team Format.' },
    { name: 'keywords', content: 'pool league, billiards, Fort Worth, competitive pool, Bad Boys Tru-Team Format' },
    // Mobile web app capabilities
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    { name: 'format-detection', content: 'telephone=no' }
  ],
  htmlAttrs: {
    lang: 'en'
  }
});
</script>
